import { render, staticRenderFns } from "./tableQuery.vue?vue&type=template&id=a44dd996"
import script from "./tableQuery.vue?vue&type=script&lang=js"
export * from "./tableQuery.vue?vue&type=script&lang=js"
import style0 from "./tableQuery.vue?vue&type=style&index=0&id=a44dd996&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports